// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"460":"166c6aa1","807":"e0575e92"}[chunkId] + ".css";
};